import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Alert } from 'antd';

const PermissionHoc = (WrappedComponent, required_permission = null, options = {}) => {
  class HOC extends Component {
    is_authorized() {
      required_permission = this.props.required_permission || required_permission || null;
      const user_permissions = this.props.current_user.user ? this.props.current_user.user.permissions : [] || [];
      return !required_permission || user_permissions.includes(required_permission)
    }

    renderFallback() {
      return (options.hasOwnProperty('fallbackComponent')) ? options.fallbackComponent : (<Alert
        message="Error"
        description="You are not authorised to view this page."
        type="error"
        showIcon
      />);
    }

    render() {
      if (this.is_authorized()) {
        return (
          <WrappedComponent {...this.props} />
        );
      } else {
        return this.renderFallback();
      }
    }
  }
  const mapStateToProps = state => ({
    current_user: state.userReducer.current_user
  });
  return connect(mapStateToProps)(HOC);
};

export { PermissionHoc };
